import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { init } from '../editorconfig';

@Component({
  selector: 'app-upload-qap-atp',
  standalone: false,
  templateUrl: './upload-qap-atp.component.html',
  styleUrl: './upload-qap-atp.component.scss',
})
export class UploadQapAtpComponent implements OnInit, OnDestroy {
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() id: any;
  commentForm: FormGroup;
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  aonSocForm!: FormGroup;
  selectedFiles: any;
  uploadedAonUrl: string | null = null;
  uploadedSocUrl: string | null = null;
  apiUrl = environment.APIUrl;
  aonID: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  selectedSOCFileName: string | null = null;
  selectedAONFileName: string | null = null;
  @ViewChild('aonUploader') aonUploader: FileUpload;
  @ViewChild('socUploader') scUploader: FileUpload;
    selectedAONFiles: File[] = [];
selectedSOCFiles: File[] = [];
  drawingFiles: any;
  docuemntdrawingFiles: any;

  private subscriptions = new Subscription();
  userID: any;

  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private route: ActivatedRoute
  ) {
    this.commentForm = this.fb.group({
      comment: ['', Validators.required],
      vendor: [''],
      // upload: ['', Validators.required],
      date: ['', Validators.required],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    // this.loadDocList();
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName,
      };
    });
    this.aonSocForm = this.fb.group({});
    this.getAonSocDetails();
    if (this.stepDetails?.can_edit) {
      this.commentForm.enable();
    } else {
      this.commentForm.disable();
    }
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.commentForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.commentForm.disable();
      }
      this.rebuildEditor();
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }


  onSubmit() {
    const formData = new FormData();
    formData.append('proposal_step', this.step.id);
    let comment = this.commentForm.get('comment').value;
    formData.append('comment', comment);
    formData.append('date', this.commentForm.get('date').value);

  if (this.selectedFiles?.['aon']) {
    for (const file of this.selectedFiles['aon']) {
      formData.append('qap_files', file);
    }
  }

  // Append SOC files correctly
  if (this.selectedFiles?.['soc']) {
    for (const file of this.selectedFiles['soc']) {
      formData.append('atp_files', file);
    }
  }

    if (this.aonID) {
      const sub = this.api
        .putAPI(`/revenue/qap/atp/${this.aonID}/`, formData)
        .subscribe({
          next: (res) => {
            this.messageService.add({
              severity: 'success',
              summary: 'Submitted',
              detail: 'Documents uploaded successfully',
            });
            // Clear uploaded files if needed
           this.selectedAONFiles = null;
            this.selectedSOCFiles = null;
            this.selectedSOCFileName = '';
            this.selectedAONFileName = '';
            this.aonUploader?.clear();
            this.scUploader?.clear();
            this.getAonSocDetails();
            // this.stepCompleted.emit();
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Upload failed',
            });
          },
        });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI('/revenue/qap/atp/', formData).subscribe({
        next: (res) => {
          this.getAonSocDetails();
          this.messageService.add({
            severity: 'success',
            summary: 'Submitted',
            detail: 'Documents uploaded successfully',
          });
          // Clear uploaded files if needed
           this.selectedAONFiles = null;
            this.selectedSOCFiles = null;
            this.selectedSOCFileName = '';
            this.selectedAONFileName = '';
            this.aonUploader?.clear();
            this.scUploader?.clear();
          // this.stepCompleted.emit();
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Upload failed',
          });
        },
      });
      this.subscriptions.add(sub);
    }
  }

  getAonSocDetails() {
    const sub = this.api
      .getAPI(
        `/revenue/qap/atp/?proposal_step=${this.step.id}&proposal_step__proposal=${this.payload.proposal_id}`
      )
      .subscribe({
        next: (res: any) => {
          // this.uploadedAonUrl = res[0]?.qap || null;
          // this.uploadedSocUrl = res[0]?.document || null;
            this.drawingFiles = res[0].qap_files || [];
          this.docuemntdrawingFiles = res[0].atp_files || [];
          this.aonID = res[0]?.id;
          this.commentForm.patchValue({
            comment: res[0].comment,
            date: res[0].date,
          });
        },
        error: (err) => {},
      });
    this.subscriptions.add(sub);
  }


  goToNextStep() {
    this.stepCompleted.emit();
  }

}

